// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_YGV","cls2":"CitingSourcesCard-cls2_7LJ CitingSourcesCard-cls1_YGV"};